import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from 'antd';
import styled from 'styled-components';

import { TariffOverride } from '../../api/contracts';

interface PricePerUnitProps {
	overrides: TariffOverride[];
}

const PricePerUnitsContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 267px;
`;

const PricePerUnitsTextStyled = styled.p`
	margin: 0;
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const PricePerUnit: FC<PricePerUnitProps> = ({ overrides }) => {
	const sortedOverrides = overrides.sort((a, b) => {
		if (!a.fromNumberOfUnits || !b.fromNumberOfUnits) {
			return 0;
		}
		if (a.fromNumberOfUnits > b.fromNumberOfUnits) {
			return 1;
		}
		if (a.fromNumberOfUnits < b.fromNumberOfUnits) {
			return -1;
		}
		// a должно быть равным b

		return 0;
	});

	const { t } = useTranslation();

	return (
		<div style={{ maxWidth: `270px` }}>
			<PricePerUnitsTextStyled>
				{t(`Marketplace_Price_Changes_With_Number_Of_Establishments`)}
			</PricePerUnitsTextStyled>
			<Divider style={{ margin: `8px 0` }} />
			{sortedOverrides.map(n => (
				// eslint-disable-next-line react/jsx-no-useless-fragment
				<>
					{n.toNumberOfUnits !== 9999 ? (
						<PricePerUnitsContainerStyled key={n.tariffId}>
							<PricePerUnitsTextStyled>
								{t(`Marketplace_Range_Units`, {
									start: n.fromNumberOfUnits ? n.fromNumberOfUnits : ``,
									end: n.toNumberOfUnits ? n.toNumberOfUnits : ``,
								})}
							</PricePerUnitsTextStyled>
							<PricePerUnitsTextStyled>{`${n.price} ₽ / ${t(
								`Marketplace_Per_Month`,
							)}`}</PricePerUnitsTextStyled>
						</PricePerUnitsContainerStyled>
					) : (
						<PricePerUnitsContainerStyled key={n.tariffId}>
							<PricePerUnitsTextStyled>
								{t(`Marketplace_Units_And_More_Establishments`, {
									units: n.fromNumberOfUnits ? n.fromNumberOfUnits : ``,
								})}
							</PricePerUnitsTextStyled>
							<PricePerUnitsTextStyled>{`${n.price} ₽ / ${t(
								`Marketplace_Per_Month`,
							)}`}</PricePerUnitsTextStyled>
						</PricePerUnitsContainerStyled>
					)}
				</>
			))}
		</div>
	);
};
